import React from 'react'
import { Link } from 'react-router-dom'

const TopBar = () => {
  return (
    <div className="topbar" style={{
      background: 'var(--navy)',
      padding: '0 40px',
      height: '64px',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      position: 'sticky',
      top: 0,
      zIndex: 100,
      boxShadow: '0 2px 20px rgba(0,0,0,0.2)'
    }}>
      <Link 
        to="/" 
        style={{
          textDecoration: 'none'
        }}
      >
        <div className="topbar-logo" style={{
          fontFamily: 'var(--font-d)',
          fontSize: '22px',
          color: 'var(--gold)',
          letterSpacing: '0.03em',
          display: 'flex',
          alignItems: 'center',
          gap: '10px'
        }}>
          <div className="dot" style={{
            width: '8px',
            height: '8px',
            borderRadius: '50%',
            background: 'var(--gold)',
            marginTop: '1px'
          }}></div>
          IPST
          <span className="topbar-tag" style={{
            fontSize: '11px',
            color: 'rgba(255,255,255,0.45)',
            fontFamily: 'var(--font-b)',
            fontWeight: '300',
            letterSpacing: '0.08em',
            textTransform: 'uppercase'
          }}>Athlete NIL Registration</span>
        </div>
      </Link>
      
      <div className="topbar-actions" style={{
        display: 'flex',
        alignItems: 'center',
        gap: '20px'
      }}>
        <Link 
          to="/athletes" 
          style={{
            fontSize: '13px',
            color: 'var(--gold)',
            textDecoration: 'none',
            fontFamily: 'var(--font-b)',
            letterSpacing: '0.06em',
            textTransform: 'uppercase',
            padding: '8px 16px',
            border: '1px solid var(--gold)',
            borderRadius: '4px',
            transition: 'all 0.2s ease'
          }}
          onMouseOver={(e) => {
            e.target.style.backgroundColor = 'var(--gold)';
            e.target.style.color = 'var(--navy)';
          }}
          onMouseOut={(e) => {
            e.target.style.backgroundColor = 'transparent';
            e.target.style.color = 'var(--gold)';
          }}
        >
          View Athletes
        </Link>
        
              </div>
    </div>
  )
}

export default TopBar
